
// return date in Month Year eg. May 2025
function formatMonthYearLabel(date, langCode) {
  const dateFormatOptions = {
    month: 'long', year: 'numeric'
  }
  return new Intl.DateTimeFormat(langCode, dateFormatOptions).format(new Date(date));
}

// return date in Month eg. April
function formatMonthLabel(date, langCode) {
  const dateFormatOptions = {
    month: 'long'
  }
  return new Intl.DateTimeFormat(langCode, dateFormatOptions).format(new Date(date));
}

// data for Asset class
export const getAssetClassChartData = (msgArray, data) => {
  const message = data.map(item => {
    const text = item.titleText + " "
      + (item.displayPercent ? item.displayPercent : '0') + " % " + " "
      + msgArray.marketValueMsg + item.value;
    return text;
  });
  const finalMsg = [msgArray.graphDesc, ...message];

  return { accessibilityLabel: finalMsg };
}

// data for Performance 
export const getPerformanceChartData = (msgArray, messages, data, displayedCurrency) => {

  const message = data.map(item => {
    const text = messages[item.titleText] + " "
      + msgArray.monthlyTxt + item.valueText + "% " + msgArray.andTxt
      + msgArray.cumulativeTxt + item.cumulativeVal + "%";
    return text;
  });
  const finalMsg = [msgArray.graphDesc, displayedCurrency, ...message];

  return { accessibilityLabel: finalMsg };
}

// data for Currency 
export const getCurrencyChartData = (msgArray, data) => {

  const message = data.map(ccy => {
    const text = msgArray.currencyMsg + " " + ccy.currency.toUpperCase() + " "
      + " % " + ccy.currencyPercentage + ", "
      + msgArray.marketValueMsg + ccy.currencyAmount;
    return text;
  })
  const finalMsg = [msgArray.graphDesc, ...message];
  return { "aria-label": finalMsg };
}


// this function returns data of min and max value of market value and date
const getMarketValueRangeWithDates = (data) => {
  return data.reduce(({ min, max, itemMin, itemMax }, v) => ({
    min: min < v.price.value ? min : v.price.value,
    max: max > v.price.value ? max : v.price.value,
    itemMin: min < v.price.value ? itemMin : v.date,
    itemMax: max > v.price.value ? itemMax : v.date,
  }), data[0]);

}

// data for Valuation 
export const getValuationChartData = (msgArray, data, langCode) => {
  const result = getMarketValueRangeWithDates(data);

  const firstDate = formatMonthYearLabel(data[0].date, langCode);
  const lastDate = formatMonthYearLabel(data[data.length - 1].date, langCode);
  const highestReportedYear = formatMonthLabel(result.itemMax, langCode);
  const lowestReportedYear = formatMonthLabel(result.itemMin, langCode)

  const label = msgArray.graphDesc + firstDate + msgArray.toText +
    lastDate + msgArray.highestMrktTxt + result.max + msgArray.reportedTxt + highestReportedYear +
    msgArray.lowestMrktTxt + result.min + msgArray.reportedTxt + lowestReportedYear;
  return { accessibilityLabel: label }

}

// data for Sub Asset group 
export const getSubAssetChartData = (msgArray, data, langCode) => {
  const result = getMarketValueRangeWithDates(data);

  const firstDate = formatMonthYearLabel(data[0].date, langCode);
  const lastDate = formatMonthYearLabel(data[data.length - 1].date, langCode);
  const highestReportedYear = formatMonthLabel(result.itemMax, langCode);
  const lowestReportedYear = formatMonthLabel(result.itemMin, langCode)

  const label = msgArray.graphDesc + firstDate + msgArray.toText +
    lastDate + msgArray.highestMrktTxt + result.max + msgArray.reportedTxt + highestReportedYear +
    msgArray.lowestMrktTxt + result.min + msgArray.reportedTxt + lowestReportedYear;
  return { accessibilityLabel: label }
}




